import React from "react";

export default function PlusInage() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77344 17.0215V14.5027H11.6984V11.5371H14.2578V14.5027H17.2234V16.9809H14.2578V19.9465H11.7391V17.0215H8.77344Z"
        fill="white"
      />
      <path
        d="M24.0891 7.39355C24.0484 4.59043 24.0484 5.28105 24.0891 2.35605C24.0891 1.74668 23.9672 1.25918 23.6016 0.85293C23.3984 0.60918 23.0734 0.487305 22.7484 0.487305H3.16719C2.92344 0.487305 2.67969 0.568555 2.47656 0.731055C2.02969 1.1373 1.86719 1.6248 1.90781 2.31543C1.94844 5.24043 1.90781 4.5498 1.90781 7.35293H1.86719C1.86719 11.4561 1.86719 14.2186 1.86719 17.5904V21.6123C1.86719 23.8061 3.49219 25.4311 5.64531 25.4311C8.12344 25.4311 10.5609 25.4311 12.9578 25.4311C15.4766 25.4311 17.9141 25.4311 20.2703 25.4311C22.3828 25.4311 24.0484 23.7654 24.0484 21.6123V13.2842C24.0891 11.3748 24.0891 9.38418 24.0891 7.39355ZM18.6453 3.16855H21.0016V5.1998H18.6453V3.16855ZM14.0953 3.16855H16.4516V5.1998H14.0953V3.16855ZM9.54531 3.16855H11.9016V5.1998H9.54531V3.16855ZM4.99531 3.16855H7.35156V5.1998H4.99531V3.16855ZM21.9766 13.3248V21.6529C21.9766 22.6279 21.2859 23.3186 20.3516 23.3186C15.6797 23.3186 10.7641 23.3186 5.72656 23.3186C4.75156 23.3186 4.06094 22.6279 4.06094 21.6123V17.5904C4.06094 14.2998 4.06094 11.6186 4.06094 7.71855H4.30469H21.7328H22.0172C21.9766 9.62793 21.9766 11.4967 21.9766 13.3248Z"
        fill="white"
      />
    </svg>
  );
}
